<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">{{words.IncomeRecord}}</p>
      <div class="btn-box">
        类型选择：
        <Select style="width:200px" @on-change="SelectChange">
          <Option v-for="item in selectItem" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
    </div>
    <div class="table-box">
      <Table size="large" :loading="loading" :columns="columns" stripe :data="data" :height="700"></Table>
    </div>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total"/>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      loading: false,
      columns: [],
      data: [],
      page: {
        p: 0,
        l: 10,
        status: true,
        type: ""
      },
      total: 0,
      selectItem: []
    };
  },
  mounted() {
    this.selectItem = [
      {
        value: 0,
        label: this.words.ExpensesUserRecharge
      },
      {
        value: 6,
        label: this.words.ExpensesPlatformRecharge
      },
      {
        value: 8,
        label: this.words.ExpensesEmployeeRecharge
      },
      {
        value: 9,
        label: this.words.ExpensesManualRefund
      },
      {
        value: 2,
        label: this.words.ExpensesAbnormalRefund
      }
    ];
    this.columns = [
      {
        title: this.words.IncomeType,
        key: "type",
        width: 240,
        className: "table-header-col",
        render: (h, data) => {
          let type = data.row.type;
          return h(
            "span",
            type === 0
              ? this.words.ExpensesUserRecharge
              : type === 6
              ? this.words.ExpensesPlatformRecharge
              : type === 8
              ? this.words.ExpensesEmployeeRecharge
              : type === 2
              ? this.words.ExpensesAbnormalRefund
              : type === 9
              ? this.words.ExpensesManualRefund
              : ""
          );
        }
      },
      {
        title: this.words.Recordingtime,
        key: "create_time",
        className: "table-header-col",
        render: (h, data) => {
          return h("span", this.$moment(new Date(data.row.create_time)));
        }
      },
      {
        title: this.words.Amount,
        key: "money",
        className: "table-header-col"
      }
    ];
    this.getList();
  },
  methods: {
    ...mapActions(["GetUserMoneyRecord"]),
    SelectChange(e) {
      this.page.p = 0;
      this.page.type = e;
      this.getList();
    },
    pageChange(e) {
      this.page.p = e - 1;
      this.getList();
    },
    sizeChange(e) {
      this.page.p = p - 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.GetUserMoneyRecord(this.page).then(res => {
        this.data = res.data;
        this.total = res.total;
        this.loading = false;
      });
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>